import redirect from '../redirect';

function reload(newUrl = '') {
  redirect(newUrl);
  window.location.reload();
}

export default reload;
